'use client';
import { useState } from 'react';
import styles from './ProductDescription.module.css';

export default function ProductDescription({ description }) {
  const [openSection, setOpenSection] = useState('description');

  const sections = [
    {
      id: 'description',
      title: 'Description',
      content: description,
    },
    {
      id: 'details',
      title: 'Product Details',
      content: (
        <ul>
          <li>Premium Quality: Pharmaceutical-grade ingredients</li>
          <li>Third-Party Tested: Verified for purity and potency</li>
          <li>Non-GMO: No genetically modified ingredients</li>
          <li>Gluten-Free: Safe for gluten-sensitive individuals</li>
        </ul>
      ),
    },
    {
      id: 'ingredients',
      title: 'Ingredients',
      content: (
        <ul>
          <li>Active Ingredient: [Primary compound]</li>
          <li>Cellulose: Vegetable capsule</li>
          <li>Magnesium Stearate: Flow agent</li>
          <li>Silicon Dioxide: Anti-caking agent</li>
        </ul>
      ),
    },
    {
      id: 'usage',
      title: 'Usage Instructions',
      content: (
        <ul>
          <li>Dosage: Take 1-2 capsules daily</li>
          <li>Timing: Best taken with meals</li>
          <li>Storage: Keep in cool, dry place</li>
          <li>Consultation: Consult healthcare provider before use</li>
        </ul>
      ),
    },
  ];

  return (
    <div className={styles.descriptionSection}>
      <h2 className={styles.mainTitle}>Product Information</h2>

      <div className={styles.accordion}>
        {sections.map((section) => (
          <div key={section.id} className={styles.accordionItem}>
            <button
              className={`${styles.accordionHeader} ${
                openSection === section.id ? styles.active : ''
              }`}
              onClick={() =>
                setOpenSection(openSection === section.id ? null : section.id)
              }
            >
              <span>{section.title}</span>
              <span className={styles.icon}>
                {openSection === section.id ? '−' : '+'}
              </span>
            </button>
            {openSection === section.id && (
              <div className={styles.accordionContent}>
                {typeof section.content === 'string' ? (
                  <p>{section.content}</p>
                ) : (
                  section.content
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
